import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  labelText: {
    lineHeight: 1
  },
  statusText: {
    lineHeight: 1
  }
});

const Status = ({ children }) => {
  const classes = useStyles();
  if (!children) {
    return null;
  }
  return (
    <div>
      <Typography variant="caption" classes={{ root: classes.labelText }}>
        <FormattedMessage id="form.toolbarStatus" />
      </Typography>
      <Typography variant="h6" classes={{ root: classes.statusText }}>
        {children.toUpperCase()}
      </Typography>
    </div>
  );
};

export default Status;
